import 'normalize.css/normalize.css';
import '@/style/global.css';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { i18n } from './i18n';
import '@/style/word.less';
createApp(App).use(store).use(router).use(ElementPlus, {
  locale: zhCn
}).use(i18n).mount('#app');